export const selectFeatureSwitches = state => state.environment.featureSwitches;
